import { Stack, Typography } from '@mui/material';

import { useIsIntakeQuestionnaireReadOnly } from '../../hooks';
import { QUESTIONNAIRE_PAGE_BOX_SX, QuestionnaireSectionLabel } from '../../../common';
import { FORTA_BLUE } from '../../../../../utils/colors';

function SubmitForm() {
  const { isCompleted, isReadOnly } = useIsIntakeQuestionnaireReadOnly();

  let title: string;
  let body: string;
  if (isCompleted) {
    title = 'Thank you! Your Intake Questionnaire has been submitted.';
    body =
      "We appreciate the information you've shared. This helps us begin the process of understanding your child's unique needs and providing the best possible support.";
  } else if (isReadOnly) {
    title = 'This Intake Questionnaire has not been concluded yet.';
    body =
      "You're viewing this questionnaire in read-only mode. It can only be concluded by the guardian once all information has been provided.";
  } else {
    title =
      'Please note that once you conclude this Intake Questionnaire, you will not be able to make any further changes. Be sure to review all information carefully before submitting.';
    body =
      'We appreciate your effort in providing the details needed to help us deliver quality ABA support for your child. Our team will be in touch soon with the next steps.';
  }

  return (
    <>
      <QuestionnaireSectionLabel variant="h5" sx={{ mb: 1.5, color: FORTA_BLUE.primary }}>
        Submit
      </QuestionnaireSectionLabel>
      <Stack gap={3} alignItems="center" sx={QUESTIONNAIRE_PAGE_BOX_SX}>
        <Typography sx={{ fontWeight: 'bold', maxWidth: '700px' }}>{title}</Typography>
        <Typography sx={{ maxWidth: '700px' }} variant="body1">
          {body}
        </Typography>
      </Stack>
    </>
  );
}

export default SubmitForm;
